export enum RoleDispatchAction {
  Id = "ROLE_ID",
  Name = "ROLE_NAME",
  Description = "ROLE_DESCRIPTION",
  Load = "LOAD_ROLE",
}
